<template>
  <div class="customerList">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <div class="total_con">
      <el-form :inline="true">
        <el-form-item label="开户人数:"><p>{{ totalNum.customerTotal }}</p></el-form-item>
        <el-form-item label="激活人数:"><p>{{ totalNum.activeTotal }}</p></el-form-item>
      </el-form>
    </div>
    <table-page ref="childTable" :pageData="pageData"></table-page>
  </div>
</template>

<script>
import Url from '@/views/agent/util/url'
import DateUtil from '@/utils/dataUtil'
import FORM from '@/components/page/form'
import tablePage from '@/components/page/table'
import download from '@/utils/download'

let statusArr = { 0: '未激活', 1: '激活' }
let platformArr = { 'GTS2': 'GTS2', 'MT5': 'MT5' }
let countryArr = { 'ISO_3166_704': '越南', 'ISO_3166_356': '印度' }
export default {
  name: 'customerList',
  components: {
    FORM,
    tablePage
  },

  data() {
    return {
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '代理編碼', field: 'code' },
          { title: '交易账号', field: 'customerNumber' },
          { title: '手机号', field: 'phone' },
          { title: '邮箱', field: 'email' },
          {
            title: '时间',
            field: 'time',
            type: 6,
            format: 'yyyy-MM-dd HH:mm:ss',
            startEndParam: ['startTime', 'endTime']
          },
          {
            title: '激活状态',
            field: 'status',
            type: 2,
            optionList: statusArr,
            data: []
          },
          {
            title: '交易平台',
            field: 'platform',
            type: 2,
            optionList: platformArr,
            data: []
          },
          { title: '廣告系列', field: 'utmCampaign' },
          { title: '媒介', field: 'utmMedium' },
          { title: '來源', field: 'utmSource' },
          { click: '当天' },
          { click: '当周' },
          { click: '当月' },
          { click: '最近三个月' },
          { click: window.$t('common.search') },
          { click: window.$t('common.export'), auth: 'analyse:customerList:export' }
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: Url.adAgent.customerList,
        selection: false,
        sequence: false,
        method: 'get',
        cols: [
          {
            title: '国籍', field: 'country', render: (data, full) => {
              return countryArr[data]
            }
          },
          { title: '交易账号', field: 'customerNumber' },
          { title: '账号级别', field: 'level' },
          { title: '客户姓名', field: 'name' },
          { title: '廣告系列', field: 'utmCampaign' },
          { title: '媒介', field: 'utmMedium' },
          { title: '來源', field: 'utmSource' },
          { title: '直属代理编码', field: 'agentCode' },
          { title: '所属一级代理编码', field: 'topAgentCode' },
          { title: '手机号', field: 'phone' },
          { title: '邮箱', field: 'email' },
          {
            title: '开户时间', field: 'ctime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '綁定關係時間', field: 'stime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '激活时间', field: 'activeTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '激活状态', field: 'status', render: (data, full) => {
              return DateUtil.isEmpty(full.activeTime) ? '未激活' : '已激活'
            }
          },
          { title: 'IP', field: 'ip' },
          { title: 'IP所在地', field: 'ipAddress' }
        ]
      },
      totalNum: {}
    }
  },
  methods: {
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    dateToString(data) {
      let date = data.replace(/-/g, '/') //必须把日期'-'转为'/'
      return new Date(date).getTime()
    },
    formatDate(data) {
      var yy = data.getFullYear()      //年
      var mm = data.getMonth() + 1     //月
      var dd = data.getDate()          //日
      var clock = yy + '-'
      if (mm < 10) clock += '0'
      clock += mm + '-'
      if (dd < 10) clock += '0'
      clock += dd + ' '
      return clock
    },
    submit(model) {
      this.dataChange(Url.adAgent.customerImport, model, res => {
        if (res.code == 0) {
          this.$refs.childUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultGetData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        data.startTime = data.startTime ? new Date(data.startTime).getTime() : ''
        data.endTime = data.endTime ? new Date(data.endTime).getTime() : ''
        this.queryData = data
        this.$refs.childTable.defaultGetData(data)
      } else if ('当天' == clickName) {
        let now = new Date()
        data.startTime = new Date(this.dateToString(this.formatDate(now) + ' 00:00:00')).getTime()
        data.endTime = now.getTime()
        this.$refs.childTable.defaultGetData(data)
      } else if ('当周' == clickName) {
        let now = new Date()
        let day = now.getDay()
        if (day == 0) {
          day = 7
        }
        now.setDate(now.getDate() - day + 1)
        data.startTime = new Date(this.dateToString(this.formatDate(now) + ' 00:00:00')).getTime()
        data.endTime = new Date().getTime()
        this.$refs.childTable.defaultGetData(data)
      } else if ('当月' == clickName) {
        let now = new Date()
        now.setDate(1)
        data.startTime = new Date(this.dateToString(this.formatDate(now) + ' 00:00:00')).getTime()
        data.endTime = new Date().getTime()
        this.$refs.childTable.defaultGetData(data)
      } else if ('最近三个月' == clickName) {
        let now = new Date()
        data.startTime = new Date(now.setMonth(now.getMonth() - 3)).getTime()
        data.endTime = new Date().getTime()
        this.$refs.childTable.defaultGetData(data)
      }
      if ('导出' == clickName || window.$t('common.export') == clickName) {
        download.exportExcel(Url.adAgent.customerDown, data, '代理客户开户明细')
      } else {
        this.getTotalNum(data)
      }
    },
    getTotalNum(option) {
      this.$axios.get(Url.adAgent.customerStatistics, { params: option }).then(res => {
        if (res.code == 0) {
          this.totalNum = res.result
        }
      })
    }
  },
  mounted() {
    this.getTotalNum({})
  }
}
</script>

<style>
.customerList .total_con {
  width: 96%;
  margin: 0 auto;
}

.customerList .total_con .el-form-item {
  margin: 0 30px 0 0;
}

.customerList .total_con p {
  color: #ff5500;
  font-size: 16px;
  font-weight: bolder;
}
</style>
